module.exports = __webpack_public_path__ + "static/img/office-01.a39568e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office-01.png
// module id = RngG
// module chunks = 0